import React, { Component } from 'react';
import { connect } from 'react-redux';
import PaymentSent from '../../components/make-purchase/payment-sent';
import { getCurrentPurchaseMerchantName, getCurrentPurchase } from '../../selectors/purchase-selector';

class PaymentSentContainer extends Component {
  constructor(props) {
    super(props);
    this.onCloseClick = this.onCloseClick.bind(this);
  }

  onCloseClick() {
    const { purchase: { slug } } = this.props;
    window.location = `/purchases/${slug}`;
  }

  render() {
    return (
      <PaymentSent
        merchantName={this.props.merchantName}
        onCloseClick={this.onCloseClick}
      />
    );
  }
}

const mapStateToProps = (state) => {
  return {
    purchase: getCurrentPurchase(state),
    merchantName: getCurrentPurchaseMerchantName(state),
  };
};

export default connect(mapStateToProps)(PaymentSentContainer);



// WEBPACK FOOTER //
// ./src/desktop/containers/make-purchase/payment-sent.container.js